import { useEffect, useState } from "react";
import Block from "../../components/Base/Block";
import Image from "../../components/Base/Image";
import Text from "../../components/Base/Text";
import View from "../../components/Base/View";
import Productinfoinorder from "../../components/ProductInfoInOrder";
import util from "../../utils/util";
import rm from "../../utils/rm";
import httpUtil from "../../utils/httpUtil";
import { toast } from "../../utils/toast";
import './detail.scss'

const AfterSaleDetail = () => {

    const [result, setResult] = useState<any>();

    useEffect(() => {
        document.title = "售后详情";
        const urlInfo = util.parasUrl(window.location.href);
        const params = urlInfo.params as any;
        if (params.id) {
            rm.showLoading({
                title: '加载中...'
            })
            httpUtil.link(
                {
                    apiName: 'getreturnrequestdetail',
                    id: params.id,
                },
                'GET',
                {},
                true,
                function (success: boolean, res: any, tips: string) {
                    rm.hideLoading()
                    console.log('售后详情', success, res, tips)
                    if (success) {
                        var result = res.data.Content
                        // result.Product.Quantity = result.Quantity;
                        result.AddTimeArray = util.getTimeArry(result.CreatedOn)
                        result.DealTimeArray = util.getTimeArry(result.UpdateOn)
                        setResult(result)
                    } else {
                        toast.error(tips, 2)
                    }
                }
            )
        }
    }, [])

    return !!result ? <View className="aftersale-detail">
        {/*  商品信息  */}
        <View className="refund-result-title refund-product-title">
            售后商品
        </View>
        {[result.OrderItem].map((productInfo, index) => {
            return (
                <Block key={productInfo.Id}>
                    <Productinfoinorder
                        productInfo={productInfo}
                        fromPage="checkout"
                        showBottomBorder={false}
                    ></Productinfoinorder>
                </Block>
            )
        })}
        {/*  订单编号、时间等信息  */}
        <View className="order-time setting-style-pannel">
            <View className="flex-conainer setting-style-item">
                <Text className="flex-grow">
                    {'售后编号：' + result.CustomNumber}
                </Text>
                <View
                    className="flex-fix copy-order-num-btn"
                    onClick={() => {
                        rm.setClipboardData(result.CustomNumber + '', function (res) {
                            toast.success('复制成功', 1000)
                        })
                    }}
                >
                    复制
                </View>
            </View>
            <View className="flex-conainer setting-style-item">
                <Text className="flex-grow">
                    {'申请操作：' + result.ReturnAction}
                </Text>
            </View>
            <View className="flex-conainer setting-style-item">
                <Text className="flex-grow">
                    {'申请原因：' + result.ReturnReason}
                </Text>
            </View>
        </View>
        {/*  申請原因  */}
        <View className="refund-result setting-style-pannel">
            <View className="refund-result-title">原因描述</View>
            {!util.isEmpty(result.Comments) ? (
                <View className="refund-result-content">
                    <Text>{result.Comments}</Text>
                </View>
            ) : (
                <View className="refund-result-content">
                    <Text>无补充内容</Text>
                </View>
            )}
            {result.PictureUrls.length > 0 && (
                <View className="refund-result-content img-list">
                    {result.PictureUrls.map((item: any, index: number) => {
                        return (
                            <View className="img-list-item">
                                <Image
                                    className="img-list-img"
                                    src={item}
                                    data-index={index}
                                    onClick={() => {
                                        rm.previewImage({
                                            url: result.PictureUrls[index],
                                            // 当前显示图片的http链接
                                            imgUrls: result.PictureUrls, // 需要预览的图片http链接列表
                                        })
                                    }}
                                ></Image>
                                {/*  <image class="post-image-delete" src="/images/ib_delete.png" data-index='{{index}}' bindtap='deleteBlock'></image>  */}
                            </View>
                        )
                    })}
                </View>
            )}
            <View className="refund-result-content">
                <Text>
                    {result.AddTimeArray[0] +
                        '-' +
                        result.AddTimeArray[1] +
                        '-' +
                        result.AddTimeArray[2] +
                        ' ' +
                        result.AddTimeArray[3] +
                        ':' +
                        result.AddTimeArray[4]}
                </Text>
            </View>
            <View className="refund-result-title">
                {result.ReturnRequestStatus}
            </View>
            <View className="refund-result-content">
                <Text>
                    {!util.isEmpty(result.StaffNotes)
                        ? result.StaffNotes
                        : '等待处理'}
                </Text>
            </View>
            <View className="refund-result-content">
                <Text>
                    {result.DealTimeArray[0] +
                        '-' +
                        result.DealTimeArray[1] +
                        '-' +
                        result.DealTimeArray[2] +
                        ' ' +
                        result.DealTimeArray[3] +
                        ':' +
                        result.DealTimeArray[4]}
                </Text>
            </View>
        </View>
    </View> : null
}

export default AfterSaleDetail;